import { createContext, useEffect, useReducer } from 'react';

import { collection, getDocs } from 'firebase/firestore';

import { db } from '../../../firebase_config';

export const useGoodsData = () => {
  const goodsRef = collection(db, 'goods');

  function reducer(state, action) {
    switch (action.type) {
      case 'goods-response':
        return {
          goodsList: action.payload,
          filters: state.filters,
          sorting: state.sorting,
        };
      case 'filter-change':
        const newFilters = { ...state.filters, ...action.payload };
        return {
          ...state,
          filters: newFilters,
        };
      case 'Price ↑':
        return {
          ...state,
          sorting: action.type,
        };
      case 'Price ↓':
        return {
          ...state,
          sorting: action.type,
        };
      case 'By name, A-Z':
        return {
          ...state,
          sorting: action.type,
        };
      case 'By name, Z-A':
        return {
          ...state,
          sorting: action.type,
        };
      case 'reset':
        return {
          ...state,
          filters: { house: 'All houses', categories: [] },
          sorting: 'By name, Z-A',
        };
      default:
        return state;
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    goodsList: [],
    filters: { house: 'All houses', categories: [] },
    sorting: 'By name, Z-A',
  });

  useEffect(() => {
    const getGoodsList = async () => {
      getDocs(goodsRef)
        .then((snapshot) => {
          dispatch({ type: 'goods-response', payload: snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) });
        })
        .catch((err) => {
          console.log(err.message);
        });
    };

    if (!state.goodsList.length) getGoodsList();
  }, []);

  return {
    state,
    dispatch,
  };
};

export const GoodsListContext = createContext({});
